import { IPrimeirosPassos } from '../settings_primeiros_passos';

export function getInfoStep(
  passos: IPrimeirosPassos[],
  config: IPrimeirosPassos[]
) {
  return passos.map(p => {
    const index = config.findIndex(it => it.passo_valor === p.passo_valor);
    if (index >= 0) {
      p.link = p.link.map(it => {
        const idx = config[index].link.findIndex(it2 => it2.passo === it.passo);
        if (idx >= 0 && !it.url) {
          return {
            ...it,
            ...config[index].link[idx]
          };
        } else {
          return {
            ...it
          };
        }
      });
      return {
        ...config[index],
        ...p
      } as IPrimeirosPassos;
    } else {
      return p;
    }
  });
}

export const CONFIG_PASSOS = [
  {
    passo_valor: 'INFO_EMPRESA',
    titulo: 'Informações da empresa',
    descricao:
      'Vamos adicionar algumas informações sobre ' +
      'o seu negócio? \nO primeiro passo é inserir informações ' +
      'da sua empresa, como logo, nome, informações sobre seu ' +
      'ramo de negócios, endereço  e contatos. Essas ' +
      'informações que serão adicionadas aqui servirão ' +
      'para nós e seus clientes sabermos um pouco mais ' +
      'sobre sua empresa e facilitar a identificação nas ' +
      'nossas bases. ',
    toolTip: 'Necessário ter concluído: Informações da empresa!',
    color: '#607D8B',
    icon: 'pi pi-fw pi-building',
    image: 'assets/images/first-steps/planning.jpg',
    link: [
      {
        passo: 'CADASTRO_EMPRESA',
        url: 'dados-empresa/editar',
        titulo: 'Editar dados da empresa'
      }
    ]
  },
  {
    passo_valor: 'INFO_EMPRESA_REGRAS',
    titulo: 'Configurações das regras de negócio',
    descricao:
      'Agora precisamos saber: como seu negócio ' +
      'funciona? \nO segundo passo é definir como o ' +
      'sistema deve agir para melhor atender as suas ' +
      'necessidades! Existem algumas regras de configuração ' +
      'que precisam ser ativadas ou desativadas para facilitar ' +
      'todo o seu controle. Caso não entenda do que se trata ' +
      'cada marcação, basta consultar os ícones informativos ' +
      'ao lado dos campos!',
    toolTip: 'Necessário ter concluído: Informações da empresa!',
    color: '#FF9800',
    icon: 'pi pi-fw pi-cog',
    image: 'assets/images/first-steps/planning-2.jpg',
    link: [
      {
        url: 'dados-empresa/settings',
        passo: 'EMPRESA_REGRAS',
        titulo: 'Editar regras de neǵocio da empresa'
      }
    ]
  },
  {
    passo_valor: 'INFO_PARCEIROS',
    titulo: 'Cadastro dos participantes',
    descricao:
      'O cadastro dos participantes no sistema é essencial para otimizar' +
      ' a comunicação e a gestão de processos. Cada grupo tem um papel específico:' +
      ' os clientes acessam produtos e serviços; os vendedores gerenciam vendas e relacionamentos;' +
      ' os fabricantes fornecem produtos e garantem qualidade; os fornecedores asseguram a disponibilidade de insumos;' +
      ' e os funcionários são responsáveis pela operação interna. Com um registro claro, é possível monitorar interações,' +
      ' melhorar a experiência do usuário e facilitar a tomada de decisões, promovendo a eficiência organizacional.',
    toolTip: 'Necessário ter concluído: Configurações das regras de negócio!',
    color: '#4A5783',
    icon: 'pi pi-fw pi-user',
    image: 'assets/images/first-steps/participantes.jpg',
    link: [
      {
        url: 'clientes/new',
        passo: 'CADASTRO_CLIENTE',
        titulo: 'Cadastro de clientes'
      },
      {
        url: 'vendedores/new',
        passo: 'CADASTRO_VENDEDOR',
        titulo: 'Cadastro de vendedores'
      },
      {
        url: 'funcionarios/new',
        passo: 'CADASTRO_FUNCIONARIO',
        titulo: 'Cadastro de funcionários'
      },
      {
        url: 'fornecedores/new',
        passo: 'CADASTRO_FORNECEDOR',
        titulo: 'Cadastro de fornecedores'
      },
      {
        url: 'fabricantes/new',
        passo: 'CADASTRO_FABRICANTE',
        titulo: 'Cadastro de fabricantes'
      }
    ]
  }
] as IPrimeirosPassos[];

export const CONFIG_PASSOS_FISCAL = [
  {
    passo_valor: 'INFO_FISCAL',
    titulo: 'Informações fiscais da empresa',
    descricao:
      'Nesse momento é importante que todos os ' +
      'dados da sua empresa sejam preenchidos corretamente, ' +
      'pois iremos cadastrar agora sua empresa como emitente! ' +
      '\nNo terceiro passo, é necessário preencher todas as ' +
      'informações sobre sua empresa que necessitam para ' +
      'emissão de documentos fiscais como CNPJ, razão social, ' +
      'inscrição estadual e municipal, ou seja, o que for ' +
      'necessário para podermos emitir os seus documentos ' +
      'fiscais com o emitente correto.',
    toolTip: 'Necessário ter concluído: Configurações das regras de negócio!',
    color: '#D60000',
    icon: 'pi pi-fw pi-building',
    image: 'assets/images/first-steps/planning-3.jpg',
    link: [
      {
        passo: 'EDITAR_FISCAL',
        url: 'dados-fiscais/editar-fiscal',
        titulo: 'Cadastro dos dados fiscais da empresa'
      }
    ]
  },
  {
    passo_valor: 'INFO_FISCAL_REGRAS',
    titulo: 'Configurações da emissão de notas fiscais',
    descricao:
      'Esse passo é extremamente importante, ' +
      'nele o sistema entenderá como deve proceder durante ' +
      'a emissão das notas! \nNo quarto passo deve ser ' +
      'inseridas as informações referentes ao cadastro da ' +
      'sua série fiscal, o ambiente de emissão (produção ou ' +
      'homologação) e, caso tenha adquirido o pacote com ' +
      'NFCe, adicionar também o código do contribuinte, ' +
      'entre outras informações solicitadas.',
    toolTip: 'Necessário ter concluído: Informações fiscais da empresa!',
    color: '#9C27B0',
    icon: 'pi pi-fw pi-cog',
    image: 'assets/images/first-steps/tax-3.jpg',
    link: [
      {
        passo: 'EDITAR_REGRA_FISCAL',
        url: 'dados-fiscais/settings-fiscal',
        titulo: 'Cadastro das regras fiscais da empresa'
      }
    ]
  },
  {
    passo_valor: 'INFO_CERTIFICADO',
    titulo: 'Configuração do certificado',
    descricao:
      'Para emissão de documentos fiscais é ' +
      'indispensável o uso de certificação digital da sua ' +
      'empresa, então esteja sempre com ele em dia! \nNo ' +
      'quinto passo deve ser enviado o certificado digital ' +
      'que sua empresa usa e a senha. Essas informações vão ' +
      'ser salvas no nosso servidor, pois sempre que for ' +
      'necessário a emissão de um documento fiscal o ' +
      'certificado estará disponível para consulta.',
    toolTip:
      'Necessário ter concluído: Configurações da emissão de notas fiscais!',
    color: '#2808DB',
    icon: 'pi pi-fw pi-file',
    image: 'assets/images/first-steps/certificado-digital.png',
    link: [
      {
        passo: 'EDITAR_CERTIFICADO',
        url: 'certificado_digital',
        titulo: 'Adição do certificado digital da empresa'
      }
    ]
  },
  {
    passo_valor: 'INFO_UFICMS',
    titulo: 'Configuração das alíquotas estaduais',
    descricao:
      'Por fim, o último passo , o preenchimento ' +
      'das alíquotas estaduais! As alíquotas são imposto de ' +
      'âmbito estadual e por isso somente os governos dos ' +
      'Estados e do Distrito Federal podem instituí-lo. ' +
      'Por isso, é importante manter em mãos a Tabela ICMS ' +
      'sempre atualizada. \nNesse último passo, precisamos ' +
      'que configure as porcentagens(alíquotas) utilizadas em ' +
      'cada estado que você emite nota. em caso de dúvidas, ' +
      'consulte o contador!',
    toolTip: 'Necessário ter concluído: Configuração do certificado!',
    color: '#673AB7',
    icon: 'pi pi-fw pi-percentage',
    image: 'assets/images/first-steps/tax-2.jpg',
    link: [
      {
        passo: 'EDITAR_UFICMS',
        url: localStorage.getItem('UFICMS_ID')
          ? `uficms/${localStorage.getItem('UFICMS_ID')}`
          : 'uficms/new',
        titulo: 'Cadastro das taxas fiscais estaduais'
      }
    ]
  }
] as IPrimeirosPassos[];

export const CONFIG_PASSOS_PROD = [
  {
    passo_valor: 'INFO_MATERIA_PRIMA',
    titulo: 'Configuração dos seus materiais',
    descricao:
      'O cadastro dos materiais utilizados na produção de peças' +
      ' é fundamental para garantir a eficiência e a qualidade do' +
      ' processo produtivo. Ao categorizar os materiais, é possível' +
      ' organizar e identificar rapidamente os tipos necessários. As variações' +
      ' de grade permitem ajustar as especificações conforme as demandas, enquanto' +
      ' o registro da matéria-prima assegura que apenas insumos de qualidade sejam utilizados.' +
      ' Essa abordagem não apenas facilita o planejamento e o controle de estoque, mas também otimiza' +
      ' a rastreabilidade e a conformidade com normas de produção.',
    toolTip: 'Necessário ter concluído: Passo anterior!',
    color: '#D60000',
    icon: 'pi pi-fw pi-box',
    image: 'assets/images/first-steps/estoque.jpg',
    link: [
      {
        url: 'categoria_materia_primas/new',
        titulo: 'Cadastro de categoria dos materiais',
        passo: 'CADASTRO_CATEGORIA_MP'
      },
      {
        url: 'variacao_materia_prima/new',
        titulo: 'Cadastro de variações dos materiais',
        passo: 'CADASTRO_VARIACAO_MP'
      },
      {
        url: 'materia_prima/new',
        titulo: 'Cadastro das matérias prima',
        passo: 'CADASTRO_MATERIA_PRIMA'
      }
    ]
  },
  {
    passo_valor: 'INFO_SERVICO',
    titulo: 'Configuração dos seus serviços',
    descricao:
      'O cadastro dos serviços terceirizados ou prestados pela fábrica' +
      ' é crucial para a gestão eficiente das operações. Ao categorizar os serviços,' +
      ' facilita-se a identificação e a priorização das necessidades, permitindo uma melhor' +
      ' alocação de recursos. Além disso, o registro detalhado dos serviços garante um acompanhamento' +
      ' eficaz da qualidade e dos prazos, assegurando que os padrões da empresa sejam atendidos. Essa prática' +
      ' não só melhora a comunicação com os prestadores de serviços, mas também contribui para o planejamento' +
      ' estratégico e a otimização dos processos internos.',
    toolTip: 'Necessário ter concluído: Cadastro dos materiais!',
    color: '#B39CD0',
    icon: 'mdi mdi-wrench-cog-outline',
    image: 'assets/images/first-steps/servicos.jpg',
    link: [
      {
        url: 'categoria_servicos/new',
        titulo: 'Cadastro de categoria dos serviços',
        passo: 'CADASTRO_CATEGORIA_SERVICO'
      },
      {
        url: 'servicos/new',
        titulo: 'Cadastro dos serviços',
        passo: 'CADASTRO_SERVICO'
      }
    ]
  },
  {
    passo_valor: 'INFO_PRODUCAO',
    titulo: 'Configuração do ambiente de produção das peças',
    descricao:
      'Cadastrar as informações referentes à produção das peças da fábrica é essencial para otimizar a eficiência operacional' +
      ' e garantir a qualidade. O cadastro de prioridades de produção ajuda a direcionar recursos de forma eficaz, enquanto o' +
      ' nível de complexidade permite um melhor planejamento. A identificação dos tipos de erro e das linhas de montagem facilita' +
      ' a análise de falhas e a melhoria contínua. Além disso, o registro das peças, etapas, processos e modelos proporciona um controle' +
      ' mais rigoroso e uma visão clara do fluxo produtivo, assegurando a conformidade e a agilidade na produção.',
    toolTip: 'Necessário ter concluído: Cadastro dos serviços!',
    color: '#008F7A',
    icon: 'mdi mdi-hammer-wrench',
    image: 'assets/images/first-steps/producao.jpg',
    link: [
      {
        url: 'prioridades/new',
        titulo: 'Cadastro de prioridades da produção',
        passo: 'CADASTRO_PRIORIDADE'
      },
      {
        url: 'niveis/new',
        titulo: 'Cadastro de níveis de produção',
        passo: 'CADASTRO_NIVEL'
      },
      {
        url: 'tipo_erro_producao/new',
        titulo: 'Cadastro de tipos de erro da produção',
        passo: 'CADASTRO_TP_ERRO_PROD'
      },
      {
        url: 'linha_montagem/new',
        titulo: 'Cadastro de linhas de montagem',
        passo: 'CADASTRO_LINHA_MONTAGEM'
      },
      {
        url: 'pecas/new',
        titulo: 'Cadastro de peças dos modelos',
        passo: 'CADASTRO_PECA'
      },
      {
        url: 'etapas/new',
        titulo: 'Cadastro de etapas das linhas de montagem',
        passo: 'CADASTRO_ETAPA'
      },
      {
        url: 'processos/new',
        titulo: 'Cadastro de processos das linhas de montagem',
        passo: 'CADASTRO_PROCESSO'
      },
      {
        url: 'modelos/new',
        titulo: 'Cadastro dos modelos das linhas de montagem',
        passo: 'CADASTRO_MODELO'
      }
    ]
  }
] as IPrimeirosPassos[];
